module.exports = __webpack_public_path__ + "static/media/no_data_gray.510b8a8f.svg";